import {Component} from "react";
import {parseQueryString} from "util/url";
import {RouteComponentProps, withRouter} from "react-router";
import RouteURLs from "RouteURLs";
import {downloadFile} from "util/file";
import {loadBookingOccupationLicense} from "services/bookings";
import {NotFoundError} from "util/errors";
import {logout} from "services/auth";

class DownloadOccupationalLicensePage extends Component<RouteComponentProps, {}> {
  componentDidMount() {
    const queryParams = parseQueryString(this.props.location.search);
    const bookingCodes = queryParams['code'].split(',');
    if(bookingCodes.length > 0) {
      for(const code of bookingCodes) {
        loadBookingOccupationLicense(code).then(
          blob => {
            downloadFile(URL.createObjectURL(blob), `occupation_license_${code}.pdf`);
          },
          (ex) => {
            if(ex instanceof NotFoundError) {
              // possibly wrong account - logout and redirect to login
              logout();
              const currentURL = this.props.location.pathname + this.props.location.search;
              this.props.history.replace(RouteURLs.LOGIN + "?redirect=" + encodeURIComponent(currentURL));
            } else {
              this.props.history.replace(RouteURLs.NOT_FOUND);
            }
          }
        );
      }
    } else {
      this.props.history.replace(RouteURLs.NOT_FOUND);
    }
  }

  render() {
    return null;
  }
}

export default withRouter(DownloadOccupationalLicensePage);